module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAArUlEQVRIx2OYzStrwsLFQH9wTlANiAbAeojFA2A9ssV0tR7TYjpZj8timluP32II2qhsVObmHUFVQJTFEHTLJ+bz4ZP/qQSwWHxJ2YwO1qNb/GLi7G9Xb15UMqW171EsPi+m9Wbhyq9nL17Rd6SrxUB0QUofiAYgqAcycWGixRp6XuF2cnluVESEChBtHZMEc4YqW+qjAbASl8U0txLTYjpZiWwxXa2EoAGwEowAhDQyfjzceQkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/jo.png
// module id = 848
// module chunks = 0